export const removeRoleFromUser = /* GraphQL */ `
  mutation RemoveRoleFromUser($userRoleId:ID!, $_version: Int!) {
    deleteUserRole(input: {
      id: $userRoleId,
      _version: $_version
    }) {
      id
    }
  }
`;